import { useEffect, useState } from "react";
import { Sparkles, X } from "lucide-react";

const MEMORIES = [
  "A #PandA moment ✨",
  "First glance — saved forever 💍",
  "13.05.2026 is almost here ❤️",
  "Counting down with love · #PandA",
];

/**
 * Periodic glassmorphism toast popups appearing softly from the right.
 */
export default function MemoryPopup() {
  const [active, setActive] = useState(null);

  useEffect(() => {
    let i = 0;
    const interval = setInterval(() => {
      const message = MEMORIES[i % MEMORIES.length];
      i += 1;
      setActive({ id: Date.now(), message });
    }, 18000);

    // First popup after 9s
    const first = setTimeout(() => setActive({ id: Date.now(), message: MEMORIES[0] }), 9000);
    return () => {
      clearInterval(interval);
      clearTimeout(first);
    };
  }, []);

  useEffect(() => {
    if (!active) return;
    const t = setTimeout(() => setActive(null), 5500);
    return () => clearTimeout(t);
  }, [active]);

  if (!active) return null;

  return (
    <div
      data-testid="memory-popup"
      className="fixed z-30 right-4 md:right-8 top-24 md:top-28 glass-card px-5 py-4 max-w-xs animate-fade-up"
      style={{ animationDuration: "0.7s" }}
    >
      <button
        type="button"
        onClick={() => setActive(null)}
        className="absolute top-1.5 right-1.5 p-1 text-ivory-dim hover:text-gold"
        aria-label="Dismiss"
        data-testid="memory-popup-close"
      >
        <X size={12} />
      </button>
      <div className="flex items-start gap-3 pr-2">
        <Sparkles size={16} className="mt-1 text-gold flex-none" />
        <p className="font-serif italic text-base text-ivory leading-snug">
          {active.message}
        </p>
      </div>
    </div>
  );
}
